import { useMemo } from 'react';
import { VerticalLayout } from './vertical-layout';

import { getSections } from './config';

export function Dashboard() {
  const sections = useMemo(() => getSections((key: string) => key), []);

  return (
    <VerticalLayout
      //@ts-ignore
      sections={sections}
      navColor={'evident'} />
  )
}
